import React, { Component } from 'react';
import { Jumbotron, Container } from 'react-bootstrap';
import LineDecoration from '../../assets/images/Line decoration.png';
import './index.scss'

import { Button } from 'react-bootstrap';

class Hero extends Component {
    constructor(props){
        super(props);
    }
    render() {
        return (
           <Container fluid className="m-0 p-0 Hero">
                <Jumbotron className="jumbotron-container row m-0">
                    <div className="col-md-12 col-lg-12">
                        <div className="text-center">
                            <h1 className="font-weight-bold">Smart City Application</h1>
                            <h1 className="font-weight-bold">in Indonesia New Capital City</h1>

                            <p className="h5 mt-2 font-weight-bold">Take part to empower Indonesia through technology</p>
                            {this.props.isLogIn ?
                            <></>:
                            <div className="mt-5">
                            <Button className="mt-0 mx-3 btn btn-secondary shadow btn-hero" href="/register">Register</Button>
                            <h5>or</h5>
                            <Button className="mt-0 mx-3 btn btn-secondary shadow btn-hero" href="/signin"> Login</Button>
                            </div>
                            }

                        </div>
                    </div>
                </Jumbotron>
                <img
                    src={LineDecoration}
                    width="100%"
                    alt="line"
                />
           </Container>
        );
    }
}

export default Hero;
